import moment from "moment";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { printChecklist, printOrder } from "../services/createPdf";
import { setPrinted } from "../reducers/apartments";

const styleLine = {
  display: "flex",
  marginTop: -1,
  backgroundColor: "#FFEF85",
};

class TableHeader extends React.Component {
  formatDate = (date, toSort) => moment(date).format(toSort ? "YYYY/MM/DD" : "DD/MM/YYYY");

  formatHour = (date) => moment(date).format("HH:mm");

  getServiceDate = (ser, toSort) => {
    return this.formatDate(
      ser.data && ser.data.length > 0
        ? ser.data[0].data_prenotazione ||
            ser.data[0].data_consegna_prevista ||
            ser.data[0].orario ||
            ser.createdAt
        : ser.createdAt,
      toSort
    );
  };

  getHourRange = (data, durata) =>
    `${this.formatHour(data)} ${
      durata ? "- " + this.formatHour(moment(data).add(durata, "minutes")) : ""
    }`;

  getServiceHour = (ser) => {
    console.log("ser", ser);
    return ser.data && ser.data.length > 0
      ? !!ser.data[0].ora_consegna_prevista
        ? ser.data[0].ora_consegna_prevista
        : !!ser.data[0].orario || !!ser.data[0].data_prenotazione
        ? this.getHourRange(ser.data[0].orario || ser.data[0].data_prenotazione, ser.data[0].durata)
        : ""
      : "";
  };

  // renderCode = (ser, apartment) => {
  //   return `${apartment.split(" ").reverse()[0]}${ser.tipologia.slice(0, 2).toUpperCase()}${
  //     ser.id
  //   }`;
  // };

  renderRepetition = (type) => {
    switch (type) {
      case "mai":
        return "Singola";
      case "ogni_giorno":
        return "Giornaliera";
      case "ogni_settimana":
        return "Settimanale";
      case "ogni_due_settimane":
        return "Ogni due settimane";
      case "ogni_mese":
        return "Mensile";
      default:
        return "Singola";
    }
  };

  getServiceDescription = (obj) => {
    let cleaned = [...obj.data];
    if (obj.data.find((o) => !!o.tipologia || !!o.numero_pacco || o.ripetizione)) {
      cleaned = cleaned.map((ser) => {
        const s = {};

        if (!!ser.numero) {
          s.numero = ser.numero + "x";
        }
        if (!!ser.tipologia) {
          s.tipologia = ser.tipologia;
        }
        if (!!ser.mittente) {
          s.mittente = ser.mittente;
        }
        if (!!ser.numero_pacco) {
          s.numero_pacco = ser.numero_pacco;
        }
        if (!!ser.ripetizione) {
          s.ripetizione = this.renderRepetition(ser.ripetizione) + ",";
        }
        if (!!ser.giorno_ripetizione) {
          s.giorno_ripetizione = ser.giorno_ripetizione + " alle";
        }
        if (!!ser.ora_ripetizione) {
          s.ora_ripetizione = ser.ora_ripetizione;
        }
        if (!!ser.descrizione) {
          s.descrizione = ser.descrizione;
        }
        return s;
      });
    } else {
      return "1x " + obj.tipologia;
    }
    return cleaned.reduce((acc, curr, i) => {
      const arr = Object.entries(curr);
      return acc + arr.map((arr) => arr[1]).join(" ") + (i === cleaned.length - 1 ? "" : ", ");
    }, "");
  };

  handlePrint = async () => {
    // printOrder([
    //   {
    //     apartment: this.props.apartmentName,
    //     orders: [this.props.servizio],
    //     code: this.renderCode()
    //   },
    // ]);
    printChecklist([
      {
        ...this.props.servizio,
        apartment: this.props.apartmentName,
        code: this.renderCode(this.props.servizio, this.props.apartmentName),
        dateToPrint: this.getServiceDate(this.props.servizio, false),
        hourToPrint: this.getServiceHour(this.props.servizio),
        descrizione: this.getServiceDescription(this.props.servizio),
      },
    ]);
    await this.props.setPrinted(this.props.servizio.id);
  };

  renderCode = () => {
    return `${
      this.props.apartmentName.split(" ").reverse()[0]
    }${this.props.servizio.tipologia.slice(0, 2).toUpperCase()}${this.props.order}`;
  };

  render() {
    const style = {
      border: "solid",
      borderWidth: 1,
    };

    // console.log("headers props", this.props);
    return (
      <Fragment>
        {this.props.length === 3 ? (
          <div style={styleLine}>
            <div
              style={{
                width: "calc(39vw - 15px)",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingLeft: 16,
              }}
            >
              Ordine: {this.renderCode()}
              <div
                onClick={this.handlePrint}
                style={{
                  marginRight: 8,
                  padding: "4px 8px",
                  backgroundColor: "rgb(255, 229, 51)",
                  borderRadius: 8,
                  fontSize: 14,
                  border: "1px solid #111",
                  cursor: "pointer",
                }}
              >
                stampa
              </div>
            </div>
            <div
              style={{
                width: "6vw",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                marginLeft: -1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: 4,
                paddingLeft: 4,
              }}
            >
              Quantità
            </div>
            <div
              style={{
                width: "6vw",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                marginLeft: -1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Prezzo
            </div>
          </div>
        ) : this.props.length === 4 ? (
          <div style={styleLine}>
            <div
              style={{
                width: "calc(27vw - 15px)",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingLeft: 16,
              }}
            >
              Ordine: {this.renderCode()}
              <div
                onClick={this.handlePrint}
                style={{
                  marginRight: 8,
                  padding: "4px 8px",
                  backgroundColor: "rgb(255, 229, 51)",
                  borderRadius: 8,
                  fontSize: 14,
                  border: "1px solid #111",
                  cursor: "pointer",
                }}
              >
                stampa
              </div>
            </div>
            <div
              style={{
                width: "calc(12vw - 9px)",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                marginLeft: -1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: 4,
                paddingLeft: 4,
              }}
            >
              Data Pren.
            </div>
            <div
              style={{
                width: "6vw",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                marginLeft: -1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: 4,
                paddingLeft: 4,
              }}
            >
              Quantità
            </div>
            <div
              style={{
                width: "6vw",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                marginLeft: -1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Prezzo
            </div>
          </div>
        ) : (
          <div style={styleLine}>
            <div
              style={{
                width: "calc(51vw - 5px)",
                border: "solid",
                borderWidth: 1,
                height: "4.0vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingLeft: 16,
              }}
            >
              Ordine: {this.renderCode()}
              <div
                onClick={this.handlePrint}
                style={{
                  marginRight: 8,
                  padding: "4px 8px",
                  backgroundColor: "rgb(255, 229, 51)",
                  borderRadius: 8,
                  fontSize: 14,
                  border: "1px solid #111",
                  cursor: "pointer",
                }}
              >
                stampa
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { setPrinted })(TableHeader);
